import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAutoSize: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="auto-size, automatic-size, page"><path fillRule="evenodd" clipRule="evenodd" d="M5.75 2C4.7835 2 4 2.7835 4 3.75V20.25C4 21.2165 4.7835 22 5.75 22H18.25C19.2165 22 20 21.2165 20 20.25V3.75C20 2.7835 19.2165 2 18.25 2H5.75ZM5.5 3.75C5.5 3.61193 5.61193 3.5 5.75 3.5H18.25C18.3881 3.5 18.5 3.61193 18.5 3.75V20.25C18.5 20.3881 18.3881 20.5 18.25 20.5H13V12.75C13 11.7835 12.2165 11 11.25 11H5.5V3.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconAutoSize;
